import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Skeleton } from "@/components/ui/skeleton";

ChartJS.register(ArcElement, Tooltip, Legend);

interface Props {
  loading: boolean;
  data: number[];
  colors: string[];
  hoverColors?: string[];
  percentage: number;
  centerText: string;
  additionalInfo: { label: string; value: number | string }[];
}

export const DonutChart = (props: Props): JSX.Element => {
  const chartData = {
    labels: [],
    datasets: [
      {
        data: props.loading ? [0, 100] : props.data,
        backgroundColor: props.colors,
        hoverBackgroundColor: props.hoverColors,
        borderWidth: 0,
      },
    ],
  };

  const options = {
    cutout: "60%",
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
    responsive: true,
  };

  return (
    <div className="w-72 mx-auto relative text-center items-center">
      <div className="w-72 mx-auto relative text-center flex items-center">
        <Doughnut data={chartData} options={options} />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-xl font-bold pointer-events-none text-center">
          {props.loading ? (
            <div className="space-y-2">
              <Skeleton className="h-10 w-20 mx-auto" />
              <Skeleton className="h-4 w-28 mx-auto" />
            </div>
          ) : (
            <>
              <span className="text-4xl font-bold">{props.percentage}%</span>
              <br />
              <span className="text-base font-normal">{props.centerText}</span>
            </>
          )}
        </div>
      </div>

      <div className="mt-5 flex justify-around">
        {props.loading
          ? [0, 1].map((index) => (
              <div key={index} className="space-y-1 text-center">
                <Skeleton className="h-8 w-16 mx-auto" />
                <Skeleton className="h-4 w-20 mx-auto" />
              </div>
            ))
          : props.additionalInfo.map((info, index) => (
              <div key={index} className="text-center">
                <p className="text-4xl font-bold m-0">{info.value}</p>
                <p className="text-base font-normal m-0">{info.label}</p>
              </div>
            ))}
      </div>
    </div>
  );
};
